import { resolve } from '@APP/mixins/dependency';
import { ConfigService } from './config-service';
import { Flavor } from '@ahoy/aquarium/dist/flavors/Flavor';

function init() {
  const flavor = (<ConfigService>resolve(ConfigService.serviceName)).get('flavor') as Flavor.KNOWN_FLAVORS;
  Flavor.setFlavor(flavor);
}
init();

export const LazyLoadService = {
  async loadByFeature(feature: string) {
    const loader = Flavor.getLoaders().find(loader => loader.feature === feature);
    if (loader) {
      return loader.load();
    }
  },

  loadLHQuestion() {
    return import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-question/lh-question');
  },

  loadLogoutRestartButtons() {
    import(/* webpackChunkName: 'restartlogout' */ '../views/components/lh-logout-restart');
    return import(/* webpackChunkName: 'restartlogout' */ '../views/components/lh-terms-privacy');
  },

  loadPostWelcomeAssets() {
    this.loadLHQuestion().then(() => {
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/phone-input');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-annual-billing');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-monthly-billing');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-side-customization');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-side-mta-customization');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-side-payments');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-side-about-us');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-side-about-us-features');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-side-about-us-new-lp');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-side-about-us-features-phone');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-custom-landing-page');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-boat-details');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-trailer-details');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-pricing-list-for-table');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-pricing-package-container-for-table');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-pricing-package-for-table');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-packages-table');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-packages-table-th');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-packages-table-container');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-tooltip');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-tooltip-mobile');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-notice');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/value-input');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/combo-box');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-address-autocomplete-only');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-date');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-combo');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/checkbox-input');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-questionnaire');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-image-upload-button');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-image-upload-button-error');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-block');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-otp');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-dropdown');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-toast');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-toast-with-backdrop');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-header-mta');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-header-get-assistance');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-logo');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-coverage-boats-details');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-mta-coverage-top');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-boats-content');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-boats-dropdown');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-coverages-desktop-top');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-coverages-mobile-top');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-side-about-us-features-item');
      import(/* webpackChunkName: 'questionnaire' */ '../views/components/lh-side-about-us-features-container');
      import( '../views/components/lh-no-known-loss');
      import( '../views/components/lh-attestation');
      import( '../views/components/lh-attestation-error-popup');
      import(/* webpackChunkName: 'questionnaire-marina' */ '../views/components/lh-additional-boaters');
      import(/* webpackChunkName: 'questionnaire-marina' */ '../views/components/lh-additional-insured');
      import(/* webpackChunkName: 'questionnaire-marina' */ '../views/components/lh-layup');
      import(/* webpackChunkName: 'questionnaire-marina' */ '../views/components/lh-loader');
      import(/* webpackChunkName: 'questionnaire-marina' */ '../views/congrats-view');
      import(/* webpackChunkName: 'questionnaire-marina' */ '../views/components/lh-boating-experience');
      // const flavor = (<ConfigService>resolve(ConfigService.serviceName)).get('flavor');
      // if (flavor === 'marina') {
      // }
    });
  },
};